import React from "react";
import {C} from "../styles";

const SLICE_COLORS = ["#C0392B", "#E07820", "#5BAD6F", "#1E6B5E", "#145048"];

export default function SurveyPieChart({survey, answers}) {
    const votes = survey.votes || [];
    const total = survey.total_votes || 0;

    const data = (answers || []).map((label, i) => {
        const found = votes.find(v => v.answer === label);
        return {label, value: found ? found.total : 0, color: SLICE_COLORS[i % SLICE_COLORS.length]};
    });

    const size = 140;
    const cx = size / 2;
    const cy = size / 2;
    const r = size / 2 - 8;

    function buildSlices() {
        if (total === 0) return [];
        let cumAngle = -Math.PI / 2;
        return data.map((d) => {
            const angle = (d.value / total) * 2 * Math.PI;
            if (angle === 0) { cumAngle += angle; return null; }
            const x1 = cx + r * Math.cos(cumAngle);
            const y1 = cy + r * Math.sin(cumAngle);
            cumAngle += angle;
            const x2 = cx + r * Math.cos(cumAngle);
            const y2 = cy + r * Math.sin(cumAngle);
            const large = angle > Math.PI ? 1 : 0;
            return {
                path: `M${cx},${cy} L${x1.toFixed(2)},${y1.toFixed(2)} A${r},${r} 0 ${large},1 ${x2.toFixed(2)},${y2.toFixed(2)} Z`,
                color: d.color,
            };
        }).filter(Boolean);
    }

    const slices = buildSlices();

    return (
        <div style={{
            border: `1px solid ${C.border}`,
            borderRadius: 10,
            padding: 16,
            marginBottom: 12,
            backgroundColor: C.surface,
        }}>
            <p style={{fontWeight: 600, fontSize: 14, marginBottom: 12, lineHeight: "20px"}}>
                {survey.question}
            </p>

            {total === 0 ? (
                <p style={{color: C.textMuted, fontSize: 13}}>Aucun vote pour ce sondage.</p>
            ) : (
                <div style={{display: "flex", gap: 24, alignItems: "center", flexWrap: "wrap"}}>
                    <svg width={size} height={size} style={{flexShrink: 0}}>
                        {slices.map((s, i) => (
                            <path key={i} d={s.path} fill={s.color} stroke="white" strokeWidth={2}/>
                        ))}
                    </svg>
                    <div style={{flex: 1, minWidth: 160}}>
                        {data.map((d, i) => {
                            const pct = total > 0 ? Math.round((d.value / total) * 100) : 0;
                            return (
                                <div key={i} style={{display: "flex", alignItems: "center", gap: 8, marginBottom: 6, fontSize: 13}}>
                                    <span style={{
                                        width: 12, height: 12, borderRadius: 2,
                                        backgroundColor: d.color,
                                        flexShrink: 0,
                                        display: "inline-block",
                                    }}/>
                                    <span style={{flex: 1}}>{d.label}</span>
                                    <span style={{fontWeight: 600, color: C.textMuted}}>
                                        {pct}% <span style={{fontWeight: 400}}>({d.value})</span>
                                    </span>
                                </div>
                            );
                        })}
                        <div style={{marginTop: 8, fontSize: 12, color: C.textMuted}}>
                            Total : {total} participation(s)
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
